const consolePrefixLogTemplate = [
  `%c{{name}}`,
  `color: white; background: {{color}}; border-radius: 3px; padding: 2px 4px`,
] as const;

export function getConsoleLogPrefix(logName: string, logColor: string) {
  return consolePrefixLogTemplate.map((str) =>
    str.replace('{{name}}', logName).replace('{{color}}', logColor)
  );
}

export function stripConsoleLogPrefix(str: string) {
  // Brittle, be sure to test!
  let [prefix, content] = str.split('; border-radius: 3px; padding: 2px 4px ');
  prefix = prefix.replace(/^%c/, '');
  const [name, color] = prefix.split(' color: white; background: ');
  return { name, color, content };
}
